(function() {
    'use strict';
    angular
        .module('dialysisApp')
        .factory('ReportGroup', ReportGroup);

    ReportGroup.$inject = ['$resource'];

    function ReportGroup ($resource) {
        var resourceUrl =  'api/report-groups/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();
